import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["available", "groups", "groupInputs"];

  connect() {
    this.availableSortable = Sortable.create(this.availableTarget, {
      group: "groups",
      animation: 150
    });

    this.groupsSortable = Sortable.create(this.groupsTarget, {
      group: "groups",
      animation: 150,
      onSort: () => this.updateGroupInputs()
    });
  }

  updateGroupInputs() {
    this.groupInputsTarget.innerHTML = "";

    this.groupsTarget.querySelectorAll("li").forEach((li) => {
      const attribute = li.dataset.attribute;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "report[groups][]";
      input.value = attribute;
      this.groupInputsTarget.appendChild(input);
    });
  }
}
